namespace TabAurous.OMS {

    @Serenity.Decorators.registerEditor()
    export class RateTypeEditor extends Serenity.Select2Editor<any, any> {

        constructor(container: JQuery) {
            super(container, null);


            this.addOption("0", "Fixed");
            this.addOption("1", "Dynamic");
        }
    }
}